import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  error: "",
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resume: (state, action) => {
      console.log("resume", action.payload)
      state.status = "succeeded"
      state.data = action.payload
    },
    signOut: (state, action) => {
      localStorage.removeItem("cipmovil-me")
      return { ...initialState }
    },
  },
  extraReducers: (builder) => {
    builder
      // sign-in
      .addCase(signIn.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.data = action.payload

        localStorage.setItem("cipmovil-me", JSON.stringify(action.payload))
      })
      .addCase(signIn.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const signIn = createAsyncThunk("/sign-in", async (arg, thunkAPI) => {
  try {
    const endpoint = `/user/sign-in`
    const { data } = await axios.post(API_ROUTE + endpoint, arg)
    console.log(data)
    return thunkAPI.fulfillWithValue(data)
  } catch (ex) {
    console.log(ex)
    return thunkAPI.rejectWithValue(ex.message)
  }
})

export const { resume, signOut } = authSlice.actions
export const getAuth = (state) => state.auth
export default authSlice.reducer
